<template>
  <div class="dashboard">
    <v-card class="glass elevation-15">
      <v-toolbar flat color="transparent" class="toolbar-wrap">
        <v-icon large color="primary" class="toolbar-icon">
          mdi-home-city
        </v-icon>
        <v-toolbar-title class="ml-3 font-weight-bold toolbar-title">
          Aforo del Fraccionamiento
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip
          dark
          :color="statusColor"
          class="status-chip"
        >
          <v-icon left small>
            mdi-circle
          </v-icon>
          {{ status }}
        </v-chip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-row class="pa-4 pa-sm-4 pa-xs-2">
        <!-- Lado izquierdo -->
        <v-col cols="12" sm="12" md="5">
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-card class="mb-4 mb-sm-0 mb-md-4 stat-card" outlined>
                <v-card-text>
                  <v-row align="center" no-gutters>
                    <v-col cols="auto" class="mr-3">
                      <v-avatar color="blue lighten-4" :size="avatarSize">
                        <v-icon color="blue" :large="!isSmallScreen">
                          mdi-account-group
                        </v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div class="subtitle-2 grey--text">
                        Residentes
                      </div>
                      <div class="stat-value font-weight-bold blue--text">
                        {{ residentes }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="12">
              <v-card class="stat-card" outlined>
                <v-card-text>
                  <v-row align="center" no-gutters>
                    <v-col cols="auto" class="mr-3">
                      <v-avatar color="orange lighten-4" :size="avatarSize">
                        <v-icon color="orange" :large="!isSmallScreen">
                          mdi-walk
                        </v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div class="subtitle-2 grey--text">
                        Visitantes
                      </div>
                      <div class="stat-value font-weight-bold orange--text">
                        {{ visitantes }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <!-- Gráfica -->
        <v-col cols="12" sm="12" md="7">
          <pie-chart
              :capacidad="capacidadMaxima"
              :total="total"
              :style="{ height: chartHeight + 'px' }"
          />
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <!-- Capacidad -->
      <v-card flat class="pa-3 pa-sm-4 pa-md-5">
        <v-row align="center">
          <v-col cols="12" sm="8">
            <div class="subtitle-2 subtitle-sm-1 grey--text">
              <v-icon color="green" :small="isSmallScreen">
                mdi-office-building
              </v-icon>
              Capacidad Total del Fraccionamiento
            </div>
            <div class="capacity-value font-weight-bold">
              {{ capacidadMaxima }}
              <span class="subtitle-2 subtitle-sm-1 grey--text">
                Personas
              </span>
            </div>
          </v-col>
          <v-col cols="12" sm="4" class="text-center text-sm-center">
            <div class="percentage-value font-weight-bold">
              {{ porcentaje }}%
            </div>
            <div class="grey--text caption-sm">
              Ocupación
            </div>
          </v-col>
        </v-row>
        <v-progress-linear
            :value="porcentaje"
            :color="statusColor"
            :height="isSmallScreen ? 14 : 18"
            rounded
            class="mt-2 mt-sm-3"
        >
            <strong class="progress-label">{{ total }} / {{ capacidadMaxima }}</strong>
        </v-progress-linear>

      </v-card>

    </v-card>

  </div>
</template>

<script>
import PieChart from './PieChart.vue'

export default {
  components: {
    PieChart
  },
  props: {
    residentes: Number,
    visitantes: Number,
    capacidadMaxima: Number
  },
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isSmallScreen () {
      return this.windowWidth < 600
    },
    avatarSize () {
      return this.isSmallScreen ? 42 : 58
    },
    chartHeight () {
      if (this.windowWidth < 600) return 200
      if (this.windowWidth < 960) return 240
      return 280
    },
    total () {
      return this.residentes + this.visitantes
    },
    porcentaje () {
      return Math.round((this.total * 100) / this.capacidadMaxima)
    },
    status () {
      if (this.porcentaje < 60) {
        return 'Normal'
      }
      if (this.porcentaje < 85) {
        return 'Medio'
      }
      return 'Saturado'
    },
    statusColor () {
      if (this.porcentaje < 60) {
        return 'green'
      }
      if (this.porcentaje < 85) {
        return 'orange'
      }
      return 'red'
    }
  },
  mounted () {
    this._onResize = () => { this.windowWidth = window.innerWidth }
    window.addEventListener('resize', this._onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this._onResize)
  }
}
</script>

<style scoped>

.dashboard {
    position: relative;
    margin: 20px auto;
    width: 100%;
    max-width: 760px;
    padding: 0 16px;
    box-sizing: border-box;
    z-index: 10;
}

.glass {
    border-radius: 18px;
    background: rgba(255, 255, 255, .94);
    backdrop-filter: blur(8px);
}

.stat-card {
    border-radius: 15px;
    transition: .3s;
}

.stat-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, .18);
}

/* Responsive stat value (replaces display-1 which is too large on mobile) */
.stat-value {
    font-size: 2rem;
    line-height: 1.2;
}

.capacity-value {
    font-size: 2rem;
    line-height: 1.2;
}

.percentage-value {
    font-size: 1.5rem;
    line-height: 1.2;
}

.progress-label {
    font-size: 0.75rem;
}

/* Toolbar wrapping */
.toolbar-wrap {
    flex-wrap: wrap;
    height: auto !important;
    min-height: 56px;
}

.toolbar-title {
    font-size: 1.1rem !important;
}

/* ---- Small screens (< 600px) ---- */
@media (max-width: 599px) {
    .dashboard {
        top: 10px;
        padding: 0 8px;
    }

    .glass {
        border-radius: 12px;
    }

    .stat-card {
        border-radius: 10px;
    }

    .stat-value {
        font-size: 1.4rem;
    }

    .capacity-value {
        font-size: 1.4rem;
    }

    .percentage-value {
        font-size: 1.2rem;
    }

    .toolbar-title {
        font-size: 0.95rem !important;
    }

    .toolbar-icon {
        font-size: 24px !important;
    }

    .progress-label {
        font-size: 0.65rem;
    }
}

/* ---- Medium screens (600px – 959px) ---- */
@media (min-width: 600px) and (max-width: 959px) {
    .stat-value {
        font-size: 1.6rem;
    }

    .capacity-value {
        font-size: 1.6rem;
    }
}

</style>
